import React from 'react'

import { ComputerIcon } from '@application/Interfaces/Icons'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Message, Wrapper } from './Error.styled'

type ErrorType = {
    message: string
    className?: string
}

export const Error = ({ message, className }: ErrorType): JSX.Element => (
    <Wrapper className={className}>
        <Grid container justifyContent="center" spacingTop={12}>
            <ComputerIcon />
        </Grid>
        <Grid container justifyContent="center" spacingTop={12}>
            <Message>{message}</Message>
        </Grid>
    </Wrapper>
)
